module.exports = __webpack_public_path__ + "static/media/shareNeeds.cdda4c6c.svg";